import { render, staticRenderFns } from "./newsProduct.vue?vue&type=template&id=c4e37afc&scoped=true"
import script from "./newsProduct.vue?vue&type=script&lang=js"
export * from "./newsProduct.vue?vue&type=script&lang=js"
import style0 from "./newsProduct.vue?vue&type=style&index=0&id=c4e37afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e37afc",
  null
  
)

export default component.exports